<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-80 md-xsmall-size-100 mx-auto">
      <simple-wizard 
        ref="wizard" 
        color="blue"
        nextButtonText="Continuar"
        finishButtonText="Concluir"
        prevButtonText="Voltar"
        v-on:tab-change="updateTabIndex()"
      >
        <template slot="header">
          <CollapseContent :active="activeTabIndex == 0">
            <template slot="md-collapse-content">
              <h3 class="title">Crie sua loja virtual em 5 minutos</h3>
            </template>
          </CollapseContent>          
        </template>

        <wizard-tab :beforechange="() => validateClient()">
          <template slot="label">
            Seus dados
          </template>
          <first-step ref="client" @on-validated="onStepValidated" @next="nextTab"></first-step>
        </wizard-tab>

        <wizard-tab :beforechange="() => validateBusiness()">
          <template slot="label">
            Seu negócio
          </template>
          <second-step ref="business" @on-validated="onStepValidated"></second-step>
        </wizard-tab>

        <wizard-tab :beforechange="() => validateAddress()">
          <template slot="label">
            Seu endereço
          </template>
          <third-step ref="address" @on-validated="onStepValidated"></third-step>
        </wizard-tab>
      </simple-wizard>
    </div>
  </div>
</template>
<script>
import FirstStep from "./Register/FirstStep.vue";
import SecondStep from "./Register/SecondStep.vue";
import ThirdStep from "./Register/ThirdStep.vue";
import Swal from "sweetalert2";
import { SimpleWizard, WizardTab } from "@/components";
import { CollapseContent } from '@/components'

export default {
  data() {
    return {      
      session: this.$store.state.client,
      client: this.$store.state.client,
      business: this.$store.state.business,
      address: this.$store.state.address,
      
      loader: this.$store.state.loader,
      info:   this.$store.state.info,

      wizardModel: {},
      startIndex: 0,
      activeTabIndex: 0,
    };
  },
  components: {
    FirstStep,
    SecondStep,
    ThirdStep,
    SimpleWizard,
    WizardTab,
    CollapseContent
  },

  mounted: function () {
    this.$nextTick(function () {
      this.$gtm.trackEvent({
        event: 'Cadastro',
        category: "lead",
        action: "view",
        transaction_id: this.$store.state.session.id,
        noninteraction: false,
      });

      this.$functions.closeInfo();

      this.$functions.setRoute(this.$route);
      if (!this.$store.state.session.email) {
        this.$router.push({ path: '/' });
      }      
    })
  },

  methods: {
    nextTab(){
      this.$refs['wizard'].nextTab();      
    },

    updateTabIndex(){
      if (this.$refs['wizard'] != undefined)
        this.activeTabIndex = this.$refs['wizard'].activeTabIndex;
    },

    validateStep(ref) {
      console.log('validateStep');
      return this.$refs[ref].validate();
    },

    validateClient() {
      this.$debug('validateClient');
      
      return this.$refs['client'].validate().then(res => {
        if (res){
          this.$debug('Client Validated');

          const date = this.$refs['client'].birthday;
          const birthday = this.$functions.dateParse(date);

          const fullName = this.$refs['client'].fullName.split(' ');
          const firstName = fullName[0];
          let lastName = '';
          for(let i = 1; i < fullName.length; i++ ){
            if (i > 1) lastName += ' ';
            lastName += fullName[i];
          }

          this.$store.commit('client', ['firstName', firstName]);
          this.$store.commit('client', ['lastName', lastName]);
          this.$store.commit('client', ['phone', this.$refs['client'].phone]);
          this.$store.commit('password', this.$refs['client'].password);

          this.$functions.saveCookie('client');

          const params = {'id'            : this.$store.state.session.id,
                          'email'         : this.$store.state.client.email,
                          'name'          : this.$store.state.client.firstName + " " + this.$store.state.client.lastName, 
                          'phone'         : this.$store.state.client.phone,
                          'birthday'      : birthday,
                          'counter_client': 1 };
          this.$functions.addTrack(params);
        }
        return res;
      })      
    },

    validateBusiness() {
      return this.$refs['business'].validate().then(res => {
        if (res){
          this.$debug('Business Validated');
          this.$store.commit('business', ['docType', this.$refs['business'].docType]);
          this.$store.commit('business', ['docNumber', this.$refs['business'].docNumber]);
          this.$store.commit('business', ['company', this.$refs['business'].company]);
          this.$store.commit('business', ['mainSegments', this.$refs['business'].mainSegments]);
          this.$store.commit('business', ['usedMarketplaces', this.$refs['business'].usedMarketplaces]);
          this.$store.commit('business', ['usedPlatforms', this.$refs['business'].usedPlatforms]);

          const params = {'id'            : this.$store.state.session.id,
                          'email'         : this.$store.state.client.email,
                          'company'       : this.$store.state.business.company,
                          'segments'      : this.$store.state.business.mainSegments.join(),
                          'marketplaces'  : this.$store.state.business.usedMarketplaces.join(),
                          'platforms'     : this.$store.state.business.usedPlatforms.join(),
                          'counter_business': 1 };
          this.$functions.addTrack(params);

          this.$functions.saveCookie('business');
        }
        return res
      })      
    },

    validateAddress() {
      return this.$refs['address'].validate().then(res => {
        if (res){
          this.$debug('Address Validated');

          this.$store.commit('address', ['CEP', this.$refs['address'].CEP]);
          this.$store.commit('address', ['street', this.$refs['address'].street]);
          this.$store.commit('address', ['number', this.$refs['address'].number]);
          this.$store.commit('address', ['complement', this.$refs['address'].complement]);
          this.$store.commit('address', ['neighborhood', this.$refs['address'].neighborhood]);
          this.$store.commit('address', ['city', this.$refs['address'].city]);
          this.$store.commit('address', ['cityCode', this.$refs['address'].cityCode]);
          this.$store.commit('address', ['state', this.$refs['address'].state]);
          this.$store.commit('address', ['stateCode', this.$refs['address'].stateCode]);
          this.$store.commit('address', ['country', this.$refs['address'].country]);

          this.$functions.saveCookie('address');

          const params = {'id'            : this.$store.state.session.id,
                          'email'         : this.$store.state.client.email,
                          'city'          : this.$store.state.address.city,
                          'state'         : this.$store.state.address.state,
                          'country'       : this.$store.state.address.country,
                          'counter_address': 1 };
          this.$functions.addTrack(params);

          this.$router.push({ path: 'dominio' });
        }
        return res;
      })      
    },

    onStepValidated(validated, model) {
      this.wizardModel = { ...this.wizardModel, ...model };      
      this.hideTabs = false;
    },

  }
};
</script>

<style lang="scss">

.md-menu.md-select .md-input{
  margin-left: 12px !important;
}

@media only screen and (max-width: 600px) {
  .md-card-wizard .choice{
    margin-top: 10px !important;
  }

  .md-card-wizard .tab-content{
    display: flex !important;
    align-items: center !important;
    padding: 0px !important;
    margin: 0px !important;
  }
  
  h3.title{
    font-size: 1.2rem !important;
    font-weight: 400 !important;
  }

}
</style>